import clsx from 'clsx';
import { LinkWithMasking } from '../../link';
import type { BreadcrumbSegmentProps } from '../types';
import styles from '../breadcrumb.module.css';

export function BreadcrumbSegment({ item, isLast, isCollapsed }: BreadcrumbSegmentProps) {
  const { title, url, isCurrentPage } = item;

  return (
    <li
      className={clsx(styles.breadcrumb__item, 'text--overline', isCollapsed && styles['breadcrumb__item--collapsed'])}
    >
      {isLast || isCurrentPage ? (
        // Current page: render as span (non-clickable)
        <span className={styles.breadcrumb__current} aria-current="page">
          {title}
        </span>
      ) : (
        // Intermediate items: render as links
        <LinkWithMasking href={url || '/'} className={styles.breadcrumb__link} masked={false} title={title}>
          {title}
        </LinkWithMasking>
      )}
    </li>
  );
}
